import { svg } from 'lit';

export const softpullAnimation = svg`
<svg id="soft-pull" class="animate" aria-hidden="true" style="overflow: visible;"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.83 129.74">
    <defs>
      <clipPath id="coinClipPath">
        <rect y="0" x="30" width="50" height="50"  fill="none" stroke-width="0"/>
      </clipPath>

      <clipPath id="groundClipPath">
            <path d="m73.08,9.23C60.82,1.45,46.31-2.71,33.36,1.97,20.23,6.71,10.21,20.83,12.91,34.53c1.3,6.61,5.27,12.72,5.05,19.44-.35,10.76-10.88,18.09-15.47,27.83-5.33,11.33-1.74,25.6,6.94,34.63,8.66,9.03,21.53,13.2,34.05,13.31,22.27.19,43.74-12.81,55.17-31.71,12.71-21.03,9.62-48.38-4.06-68.33-5.07-7.41-12.71-14.87-21.52-20.46Z"  fill="none" stroke="0" stroke-width="0"/>
      </clipPath>
    </defs>

    <path class="bg" d="m73.08,9.23C60.82,1.45,46.31-2.71,33.36,1.97,20.23,6.71,10.21,20.83,12.91,34.53c1.3,6.61,5.27,12.72,5.05,19.44-.35,10.76-10.88,18.09-15.47,27.83-5.33,11.33-1.74,25.6,6.94,34.63,8.66,9.03,21.53,13.2,34.05,13.31,22.27.19,43.74-12.81,55.17-31.71,12.71-21.03,9.62-48.38-4.06-68.33-5.07-7.41-12.71-14.87-21.52-20.46Z" fill="#b3cdde" stroke-width="0"/>
    <g clip-path="url(#groundClipPath)">
      <path class="ground" d="m1.1,102.87c25.78-9.35,72.56-9.74,94.52-.71" fill="none" stroke="#013d5b" stroke-miterlimit="10" stroke-width="1.04"/>
    </g>
    <g class="pig">
      <path class="back-ear" d="m25.12,39.39c1.96,0,3.9.38,5.71,1.13,1.81.75,3.45,1.85,4.84,3.23,1.38,1.39,2.48,3.03,3.23,4.84.75,1.81,1.13,3.75,1.13,5.71,0,.17-.07.33-.19.45-.12.12-.28.18-.45.18h-14.28c-.17,0-.33-.07-.45-.18-.12-.12-.18-.28-.18-.45v-14.28c0-.08.02-.17.05-.24.03-.08.08-.15.14-.21.06-.06.13-.11.21-.14.08-.03.16-.05.24-.05Z" fill="#013d5b" stroke-width="0"/>
      <path class="front-leg-2" d="m38.77,98.17l-6.78-.97c-.45-.07-.86-.29-1.15-.64-.29-.34-.45-.78-.43-1.23l.31-9.24c0-.26.07-.51.18-.74.11-.23.27-.44.47-.6.2-.17.43-.29.68-.36.25-.08.51-.09.77-.05l8.77,1.25c.26.04.5.12.72.27.22.13.41.32.55.53.15.21.24.45.29.71.05.25.04.51-.03.76l-2.29,8.96c-.11.44-.38.82-.76,1.06-.38.25-.84.36-1.29.29Z" fill="#013d5b" stroke-width="0"/>
      <path class="back-leg-2" d="m65.87,94.81l-5.75,3.41c-.39.22-.84.3-1.28.2-.43-.09-.83-.34-1.1-.7l-5.53-7.41c-.15-.2-.26-.44-.32-.69-.06-.25-.07-.51-.02-.76.05-.25.14-.49.29-.7.14-.21.33-.38.55-.51l7.44-4.41c.22-.13.46-.21.71-.24.25-.03.51,0,.75.08.24.07.47.21.66.38.19.16.35.38.45.61l3.84,8.41c.19.41.22.87.09,1.31-.13.42-.42.79-.8,1.02Z" fill="#013d5b" stroke-width="0"/>
      <path class="front-leg" d="m47.68,95.82l-6.33,2.63c-.42.17-.89.19-1.32.03-.43-.14-.78-.45-1-.84l-4.45-8.11c-.12-.22-.2-.48-.22-.73-.02-.26.01-.52.1-.76.08-.25.22-.47.4-.65.18-.19.39-.34.63-.44l8.18-3.4c.24-.1.5-.15.76-.14.26,0,.51.06.75.18.23.11.44.27.61.46.16.19.29.42.36.67l2.6,8.88c.13.43.09.9-.11,1.3-.2.41-.54.73-.96.91Z" fill="#f7aca3" stroke-width="0"/>
      <path class="back-leg" d="m62.7,98.34l-6.39-1.99c-.42-.13-.78-.42-1.01-.8-.22-.39-.3-.85-.21-1.29l1.79-9.07c.05-.25.15-.49.3-.7.15-.21.34-.39.55-.52.22-.14.46-.22.71-.25.25-.04.51-.01.75.06l8.26,2.57c.24.08.47.2.65.37.19.17.34.37.45.61.11.23.16.48.16.74,0,.25-.05.51-.15.74l-3.67,8.49c-.18.41-.5.75-.91.93-.41.19-.86.22-1.29.1Z" fill="#f7aca3" stroke-width="0"/>
      <path class="tail" d="m88.43,76.15c-.39,0-.77-.16-1.04-.43-.28-.28-.43-.65-.43-1.04s.16-.77.43-1.04c.28-.28.65-.43,1.04-.43.66,0,1.3-.19,1.85-.56.55-.37.98-.89,1.23-1.5.25-.61.32-1.28.19-1.93-.13-.64-.45-1.24-.91-1.7-.47-.47-1.06-.79-1.71-.91-.65-.13-1.32-.06-1.93.19-.61.25-1.13.69-1.5,1.23-.37.55-.56,1.19-.56,1.86.01.2-.02.41-.08.59-.07.19-.17.36-.31.51-.14.15-.3.27-.49.35-.19.08-.38.13-.59.13s-.4-.04-.59-.13c-.19-.08-.35-.19-.49-.35-.14-.14-.24-.31-.31-.51-.07-.19-.1-.39-.08-.59,0-1.24.37-2.45,1.06-3.48.69-1.03,1.67-1.83,2.82-2.31,1.15-.47,2.41-.6,3.62-.35s2.33.84,3.21,1.72,1.47,2,1.72,3.22c.24,1.21.12,2.47-.36,3.63-.48,1.14-1.28,2.13-2.31,2.81-1.03.69-2.24,1.06-3.49,1.06Z" fill="#013d5b" stroke-width="0"/>
      <path class="body" d="m62.72,44.77h-24.79c-9.59,0-17.79,5.94-21.12,14.34h-4.29v20.62h6.28c4.04,6.29,11.09,10.46,19.12,10.46h24.79c12.55,0,22.72-10.17,22.72-22.71s-10.17-22.71-22.72-22.71Z" fill="#f7aca3" stroke-width="0"/>
      <path class="front-ear" d="m31.12,37.91c4.02,0,7.88,1.57,10.73,4.36,2.84,2.79,4.44,6.58,4.44,10.53,0,.17-.07.33-.19.45-.12.12-.28.19-.45.19h-14.55c-.17,0-.33-.07-.45-.19-.12-.12-.19-.28-.19-.45v-14.28c0-.17.07-.33.19-.45.12-.12.28-.18.45-.18l.03.02Z" fill="#f7aca3" stroke-width="0"/>
      <path class="eye" d="m28.05,65.09c-.2,0-.39-.04-.57-.11-.18-.07-.34-.18-.48-.32-.14-.14-.25-.3-.32-.47-.07-.18-.11-.37-.11-.56v-4.16c-.01-.2.02-.4.08-.59.07-.19.18-.36.32-.5.14-.14.31-.26.5-.34.19-.08.39-.12.59-.12s.41.04.59.12c.19.08.36.2.5.34.14.15.25.32.32.5.07.19.1.39.08.59v4.16c0,.19-.04.38-.11.56-.07.18-.19.34-.33.48-.14.14-.31.24-.49.32-.18.07-.38.11-.58.11Z" fill="#013d5b" stroke-width="0"/>
      <g class="nose">
        <path d="m17.68,74.66v-10.47c0-2.89-2.31-5.23-5.16-5.23s-5.16,2.34-5.16,5.23v10.47c0,2.89,2.31,5.23,5.16,5.23s5.16-2.34,5.16-5.23Z" fill="#df5752" stroke-width="0"/>
        <path d="m14.04,69.88c-.12,0-.24-.03-.35-.07-.11-.05-.21-.13-.29-.22-.08-.09-.15-.2-.2-.32-.05-.12-.07-.26-.07-.39v-2.47c-.01-.14,0-.28.05-.4.04-.14.11-.25.19-.35.09-.1.19-.18.3-.24.12-.05.24-.09.37-.09s.25.03.37.09c.12.06.22.14.3.24.09.1.15.22.19.35.04.13.06.27.05.4v2.47c0,.14-.02.27-.07.39-.05.12-.11.23-.2.32-.08.09-.18.17-.3.22-.11.04-.23.07-.35.07Z" fill="#003d58" stroke-width="0"/>
        <path d="m9.64,69.88c-.28,0-.55-.1-.75-.29-.2-.19-.31-.45-.31-.72v-2.51c0-.28.11-.53.31-.72.2-.19.47-.3.75-.3s.55.11.75.3c.2.19.31.45.31.72v2.51c0,.28-.11.53-.31.72-.2.19-.47.29-.75.29Z" fill="#003d58" stroke-width="0"/>
      </g>
      <path class="coinslot" d="m59.37,48.06h-18.38c-.26,0-.5.09-.69.26-.18.17-.28.4-.28.63s.1.47.28.63c.18.17.43.26.69.26h18.38c.26,0,.5-.09.69-.26.18-.17.28-.4.28-.63s-.1-.47-.28-.63-.43-.26-.69-.26Z" fill="#013d5b" stroke-width="0"/>
      
      <g class="coins" clip-path="url(#coinClipPath)">
      <g class="large-coin">
        <circle cx="46.75" cy="21.61" r="6.5" fill="#fedc7d" stroke-width="0"/>
        <path d="m48.4,22.35c-.19.41-.52.72-.93.88h-.06c-.26.09-.55.12-.82.07s-.54-.16-.76-.33c-.17-.14-.32-.31-.43-.5-.13-.22-.2-.46-.23-.71-.02-.25,0-.51.09-.75.08-.24.21-.46.38-.64.17-.18.38-.32.61-.41l.06-.02c.41-.15.87-.12,1.26.07.06.03.12.05.19.05.07,0,.13,0,.19-.03.06-.02.12-.06.17-.1.05-.05.09-.1.12-.16.03-.06.04-.13.05-.2,0-.07,0-.14-.03-.2s-.06-.12-.1-.17c-.04-.05-.1-.09-.16-.12-.49-.24-1.04-.32-1.58-.23l-.28-.74c-.04-.11-.11-.21-.21-.28-.1-.06-.22-.09-.34-.08-.07.01-.14.04-.21.08-.06.04-.11.1-.15.17-.04.07-.06.14-.07.22,0,.08,0,.15.03.23l.27.77c-.62.37-1.07.99-1.25,1.7-.1.37-.11.77-.04,1.15.07.45.24.87.51,1.23.26.36.61.65,1.01.84.49.24,1.04.32,1.58.23l.27.75c.04.12.11.21.21.28.1.06.22.09.34.08.07-.01.15-.04.21-.08.06-.04.11-.1.15-.17.04-.07.06-.14.07-.22,0-.08,0-.15-.03-.23l-.27-.77c.47-.28.84-.71,1.07-1.21.03-.07.05-.15.05-.23,0-.08-.02-.15-.05-.22-.03-.07-.08-.13-.14-.18-.06-.05-.13-.08-.2-.1-.11-.02-.22,0-.32.05-.1.05-.18.14-.23.24Z" fill="#e8ad11" stroke-width="0"/>
      </g>
      <g class="small-coin">
        <circle cx="60.3" cy="36.15" r="4.05" fill="#fedc7d" stroke-width="0"/>
        <path d="m60.47,37.27c-.28.04-.55-.02-.78-.18l-.02-.03c-.14-.11-.25-.24-.32-.4s-.1-.33-.08-.51c.01-.14.05-.27.12-.4.07-.14.17-.26.3-.36.12-.1.27-.17.42-.21.15-.04.31-.04.46-.02.15.03.3.09.42.18l.03.02c.22.16.36.41.39.68,0,.04.02.08.04.12.02.04.05.07.08.09.03.02.07.04.11.05.04,0,.08.01.12,0,.04,0,.08-.02.12-.04.04-.02.07-.05.09-.08s.04-.07.06-.11c.01-.04.01-.08,0-.12-.04-.34-.19-.65-.42-.9l.29-.39c.05-.06.07-.13.07-.21,0-.07-.03-.15-.07-.2-.03-.03-.07-.06-.11-.08-.04-.02-.09-.03-.14-.02-.05,0-.09.02-.14.04-.04.02-.08.05-.11.09l-.31.4c-.41-.19-.88-.22-1.31-.07-.23.08-.44.2-.61.37-.21.19-.37.42-.47.68-.1.26-.13.54-.09.81.04.34.19.65.42.9l-.3.39c-.05.06-.07.13-.07.21,0,.07.03.15.08.2.03.04.07.06.11.08.04.02.09.03.14.02.05,0,.09-.02.14-.04.04-.02.08-.05.11-.09l.31-.4c.31.15.65.2,1,.14.05,0,.09-.02.13-.05.04-.03.07-.06.1-.1.03-.04.04-.09.05-.14,0-.05,0-.1-.02-.14-.03-.06-.08-.12-.14-.15-.06-.03-.13-.05-.2-.04Z" fill="#e8ad11" stroke-width="0"/>
      </g>
      </g>
    
    </g>
    <line class="line-2" x1="108" y1="35.56" x2="116.19" y2="31.85" fill="none" stroke="#b3cdde" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.5"/>
    <line class="line-3" x1="110.61" y1="48.29" x2="119.58" y2="49.12" fill="none" stroke="#b3cdde" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.5"/>
    <line class="line-1" x1="100.5" y1="26.38" x2="105.69" y2="19.03" fill="none" stroke="#b3cdde" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.5"/>
    <style>
      #soft-pull {
        height: 20rem;
      }
      @media (max-width: 23.438rem) {
        #soft-pull {
          height: 15rem;
        }
      }

      #soft-pull.animate .front-leg,
      #soft-pull.animate .front-leg-2 {
        transform-origin: 40px 85px;
        animation: .5s frontlegs alternate-reverse infinite;
      }
      #soft-pull.animate .back-leg {
        transform-origin: 64px 85px;
        animation: .5s backlegs alternate-reverse infinite;
      }
      
      #soft-pull.animate .back-leg-2 {
        transform-origin: 52px 90px;
        animation: .5s backlegs2 alternate-reverse infinite;
      }

       #soft-pull.animate .pig {
        animation: .5s pigRun alternate-reverse cubic-bezier(0.33, 1, 0.68, 1) infinite;
      }

       #soft-pull.animate .tail {
        transform-origin: 70px 67px;
        animation: .5s tail alternate-reverse  infinite;
      }

       #soft-pull.animate .eye {
        transform-origin: 28px 58px;
        animation: .5s eyes alternate-reverse infinite;
      }
       #soft-pull.animate .ground {
        animation: .5s ground alternate-reverse infinite;
      }

       #soft-pull.animate .large-coin {
         transform-origin: 47px 21px;
        animation: .5s largeCoins alternate-reverse cubic-bezier(0, 0.55, 0.45, 1) infinite;
      }
       #soft-pull.animate .small-coin {
         transform-origin: 60px 36px;
        animation: .5s smallCoins alternate-reverse cubic-bezier(0, 0.55, 0.45, 1) infinite;
      }

       #soft-pull.animate .front-ear,
       #soft-pull.animate .back-ear {
        transform-origin: 32px 50px;
        animation: .5s ears alternate-reverse cubic-bezier(0.83, 0, 0.17, 1) infinite;
      }

      #soft-pull.animate .line-1,
      #soft-pull.animate .line-2,
      #soft-pull.animate .line-3 {
        transform: scale(0)
      }

      #soft-pull.animate.success .line-1,
      #soft-pull.animate.success .line-2,
      #soft-pull.animate.success .line-3 {
          transform-origin: 82px 48px;
          animation:  .2s linesAppear ease-out  forwards,
                      1s linesSuccess alternate ease-in-out infinite;
    }

      #soft-pull.animate.success .line-1  {
            animation-delay: .2s, .5s;
      }
      #soft-pull.animate.success .line-2 {
            animation-delay: .15s, .4s;
      }
      #soft-pull.animate.success .line-3 {
            animation-delay: .25s, .6s;
      }


      @keyframes frontlegs {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(50deg);
        }
      }
      @keyframes backlegs {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(-50deg);
        }
      }
      @keyframes backlegs2 {
        from {
          transform: rotate(25deg) translateY(-4px);
        }
        to {
          transform: rotate(-25deg) translateY(0px);
        }
      }
      @keyframes pigRun {
        0% {
          transform: translateY(10px) scaleY(.9);
        }
        100% {
          transform: translateY(-5px) scaleY(1);
        }
      }

      @keyframes ears {
        0% {
          transform: rotate(-8deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }

      @keyframes tail {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(-12deg);
        }
      }

      @keyframes eyes {
        0% {
          transform: scaleY(.7) translateY(3px);
        }
        100% {
          transform: scaleY(1) translateY(0px);
        }
      }

      @keyframes largeCoins {
        0% {
          transform: translateY(50px) translateX(5px) rotate(90deg);
        }
        100% {
          transform: translateY(0px) translateX(0px) rotate(0deg);
        }

      }

      @keyframes smallCoins {
        0% {
          transform: translateY(40px) translateX(-15px) rotate(-90deg);
        }
        100% {
          transform: translateY(0px) translateX(0px) rotate(0deg);
        }

      }

      @keyframes ground {
          to {
            transform: translateY(4px);
          }
      }

      @keyframes linesAppear {
        0% {
              transform: scale(0);
        }
        100% {
              transform: scale(.95);
        }
      }
      @keyframes linesSuccess {
        0% {
              transform: scale(.95);
        }
        100% {
              transform: scale(.88);
        }
      }


    </style>
</svg>
`;
